import Repository from '../Repository'

export default {
  templates: (limit) => {
    return Repository.get('/line-messages/templates?limit=' + limit)
  },
  history: (limit) => {
    return Repository.get('/line-messages/history?limit=' + limit)
  },
  delTemplate: (templateId) => {
    return Repository.delete('/line-messages/templates/' + templateId)
  },
  drafts: (limit) => {
    return Repository.get('/line-messages/drafts?limit=' + limit)
  },
  filters: () => {
    return Repository.get('/line-messages/filters')
  },
  show: (id) => {
    return Repository.get('/line-messages/' + id)
  },
  update: (payload) => {
    return Repository.put('/line-messages/' + payload.id, payload)
  },
  save: (payload) => {
    return Repository.post('/line-messages', payload)
  },
  getRemindTemplate: () => {
    return Repository.get('/line-messages/remind')
  },
  getLineInfo: () => {
    return Repository.get('/line-messages/quota/info')
  },
  getThankTemplates: () => {
    return Repository.get('/line-messages/thanks')
  },
  saveRemindTemplate: (payload) => {
    return Repository.post('/line-messages/remind', payload)
  },
  saveThankTemplate: (payload) => {
    return Repository.post('/line-messages/thanks', payload)
  },
}
